import { faMagnifyingGlass, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IFortuneLabCode } from '../../../../store/useFortuneLabCode';
import Select from '../../../form/Select';
import Input from '../../../form/Input';
import DatePickerInput from '../../../form/DatePickerInput';
import { useCallback } from 'react';

interface PerformanceFilterProps {
  trkId: string;
  onTrkIdChange: (value: string) => void;
  name: string;
  onNameChange: (value: string) => void;
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  pageSize: string;
  onPageSizeChange: (value: string) => void;
  onSubmit: () => void;
  onDownload: () => void;
  codes: IFortuneLabCode[];
  /** ADMIN일 때만 이름/전화번호 검색 입력 노출 */
  showAdminFilters?: boolean;
}

const PerformanceFilter = ({
  trkId,
  onTrkIdChange,
  name,
  onNameChange,
  phoneNumber,
  onPhoneNumberChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  pageSize,
  onPageSizeChange,
  onSubmit,
  onDownload,
  codes,
  showAdminFilters = false,
}: PerformanceFilterProps) => {
  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  return (
    <form
      onSubmit={handleSubmit}
      className="!flex !flex-wrap !items-center !gap-3 !w-full"
    >
      <Select
        style={{ width: 120 }}
        value={pageSize}
        onChange={event => onPageSizeChange(event.target.value)}
        options={[
          { option: '20개 보기', value: '20' },
          { option: '50개 보기', value: '50' },
          { option: '100개 보기', value: '100' },
        ]}
      />

      <Select
        style={{ width: 200 }}
        value={trkId}
        onChange={event => onTrkIdChange(event.target.value)}
        options={[
          { option: '전체 캠페인', value: '' },
          ...codes.map(code => ({
            option: `${code.campaignName} (${code.trkId})`,
            value: code.trkId,
          })),
        ]}
      />

      {showAdminFilters && (
        <>
          <Input
            value={name}
            onChange={event => onNameChange(event.target.value)}
            placeholder="이름"
            textAlign="left"
            width={140}
          />
          <Input
            value={phoneNumber}
            onChange={event => onPhoneNumberChange(event.target.value)}
            placeholder="전화번호"
            textAlign="left"
            width={160}
          />
        </>
      )}

      <div className="!flex !items-center !gap-1">
        <DatePickerInput
          value={startDate}
          onChange={onStartDateChange}
          placeholder="시작일"
          width={130}
        />
        <span className="!text-gray-400">~</span>
        <DatePickerInput
          value={endDate}
          onChange={onEndDateChange}
          placeholder="종료일"
          width={130}
        />
      </div>

      <button
        type="submit"
        className="!px-4 !py-2 !rounded !bg-blue-600 !text-white hover:!bg-blue-700 !flex !items-center !gap-2"
      >
        <FontAwesomeIcon icon={faMagnifyingGlass} />
        조회
      </button>

      <button
        type="button"
        className="!px-4 !py-2 !rounded !bg-green-600 !text-white hover:!bg-green-700 !flex !items-center !gap-2"
        onClick={onDownload}
      >
        <FontAwesomeIcon icon={faFileArrowDown} />
        엑셀 다운로드
      </button>
    </form>
  );
};

export default PerformanceFilter;
